import { useEffect, useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useParams } from 'react-router-dom';

import { Pagination } from '../../components/Pagination';

import { SkuProductsForm } from './forms/SkuProductsForm';

import {
  createSkuProducts,
  fetchListSkuProducts,
  selectSkuProductsEntity,
} from './skuProductsSlice';
import { selectSku } from './skuSlice';

export function SkuProducts() {
  const dispatch = useDispatch();
  const { skuId } = useParams();
  const sku = useSelector(selectSku(skuId));
  const skuProducts = useSelector(selectSkuProductsEntity);
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchListSkuProducts({ skuId, params: { page } }));
  }, [dispatch, page, skuId]);

  if (!sku) {
    return <Redirect to="/admin" />;
  }

  return (
    <Row>
      <Col>
        <h4>
          <Link to="/admin/sku">&#8592;</Link>
          Danh Sách Serial <Badge variant="info">{sku.skuId}</Badge>
        </h4>
        <p>{sku.skuName}</p>
        <hr />
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>Serial</th>
              <th>Ngày Tạo</th>
            </tr>
          </thead>
          <tbody>
            {skuProducts.ids.map((id) => (
              <tr key={id}>
                <td>{skuProducts.entities[id].productId}</td>
                <td>
                  {format(
                    new Date(skuProducts.entities[id].creationDate),
                    'dd/MM/yyyy HH:mm:ss'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={page}
          totalItem={skuProducts.total}
          onPageChange={(page) => setPage(page)}
        />
      </Col>
      <Col md={3}>
        <h4>Tạo Serial</h4>
        <hr />
        <SkuProductsForm
          alert={
            alert && <Alert variant={alert.variant}>{alert.content}</Alert>
          }
          onSubmit={async (data, e) => {
            setAlert(null);

            try {
              const result = await dispatch(
                createSkuProducts({
                  quantity: Number(data.quantity),
                  skuId,
                })
              );

              unwrapResult(result);
              setAlert({ variant: 'success', content: 'Thành công!' });
              e.target.reset();
            } catch (e) {
              console.log(e);
              setAlert({ variant: 'danger', content: e.message });
            }
          }}
        />
      </Col>
    </Row>
  );
}
